module.exports = __webpack_public_path__ + "4a8788c7586c3074d5c9c57ade7626ac.svg";